export default [{
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_1.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_2.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_3.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_4.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_5.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_6.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_7.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_8.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_9.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_10.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_11.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_12.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_13.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_14.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_15.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_16.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_17.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_18.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_19.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_20.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_21.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_22.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_23.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_24.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_25.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_26.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_27.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_28.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_29.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_30.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_31.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_32.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_33.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_34.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_35.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_36.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_37.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_38.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_39.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_40.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_41.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_42.jpg"
}, {
  "img": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/history/2jie/2jie_43.jpg"
}]


// WEBPACK FOOTER //
// ./src/pages/history/jie2.js